// extracted by mini-css-extract-plugin
export default {"avatarSpace":"Avatar_avatarSpace__Ne16V","textInitials":"Avatar_textInitials__FQ0fw"};